export default function ucFirst(text: string) {
  return text.charAt(0).toUpperCase() + text.slice(1);
}